"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = require("@folio/stripes/components");
var _SearchField = _interopRequireDefault(require("../../../styles/SearchField.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Accepts the same props as TextField
const propTypes = {
  ariaLabel: _propTypes.default.string,
  clearSearchId: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  onClear: _propTypes.default.func
};
const SearchField = props => {
  const {
    ariaLabel,
    ...rest
  } = props;
  const searchIcon = /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Icon, {
    icon: "search",
    iconClassName: _SearchField.default.searchIcon,
    size: "small"
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.TextField, {
    ...rest,
    "aria-label": rest['aria-label'] || ariaLabel,
    focussedclass: _SearchField.default.isFocused,
    hasClearIcon: true,
    startControl: searchIcon,
    type: "search"
  });
};
SearchField.propTypes = propTypes;
var _default = exports.default = SearchField;